import constant from "../_config/constant";
import { handleResponse } from "../_helpers/utils";
import {
  authHeader,
  // logout,
  basicAuthHeader,
} from "../_helpers";


//
const getSubscriptionPlans = async () => {
  const APP_ENV = process.env.REACT_APP_APP_ENV
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ isDev: (APP_ENV == 'dev' || APP_ENV == 'staging') }),
  };
    return fetch(`${constant.apiUrl}/subscription/list`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

const getSubscriptionInfo = async () => {
  const APP_ENV = process.env.REACT_APP_APP_ENV
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ isDev: (APP_ENV == 'dev' || APP_ENV == 'staging')}),
  };
    return fetch(`${constant.apiUrl}/subscription/info`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });

}

const getSources = async (detailed) => {
  const addBank = process.env.REACT_APP_BANK_SOURCES == 'true'
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ detailed, addBank }),
  };
    return fetch(`${constant.apiUrl}/subscription/sources`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });

}

const subscribe = async (subscriptionPlanId) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ planId: subscriptionPlanId}),
  };
    return fetch(`${constant.apiUrl}/subscription/add`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

const updateSubscription = async (subscriptionPlanId, type) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ planId: subscriptionPlanId, type}),
  };
    return fetch(`${constant.apiUrl}/subscription/update`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

// const changePlan = async (subscriptionPlanId) => {
//   const requestOptions = {
//     method: "POST",
//     headers: { ...authHeader(), "Content-Type": "application/json" },
//     body: JSON.stringify({ planId: subscriptionPlanId}),
//   };
//     return fetch(`${constant.apiUrl}/subscription/change`, requestOptions)
//     .then(handleResponse)
//     .then((res) => {
//       return res;
//     });
// }

const makePrimary = async (sourceId) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ sourceId }),
  };
    return fetch(`${constant.apiUrl}/subscription/makePrimary`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}


const createFinancialConnectionsSession = async () => {
  try {
    //const return_url =  window.location.origin + '/bank-verification-complete'
    const return_url = window.location.toString().replace("http://", 'https://')
    const requestOptions = {
      method: "POST",
      headers: { ...authHeader(), "Content-Type": "application/json" },
      body: JSON.stringify({
        return_url
      }),
    };
    return fetch(`${constant.apiUrl}/subscription/create-financial-connections-session`, requestOptions).then(handleResponse)
    .then((res) => {
      return res;
    });
  } catch (error) {
    console.error('Error creating Financial Connections session:', error);
    throw error;
  }
};


const getMyIp = async () => {
  return await fetch('https://api.ipify.org?format=json')
}

const processVerificationResult = async (accounts) => {
  try {
    const ip = await (await getMyIp()).json()
    const requestOptions = {
      method: "POST",
      headers: { ...authHeader(), "Content-Type": "application/json" },
      body: JSON.stringify({
        accounts,
        ip: ip.ip
      }),
    };
    return fetch(`${constant.apiUrl}/subscription/process-bank-account`, requestOptions).then(handleResponse)
    .then((res) => {
      return res;
    });
  } catch (error) {
    console.error('Error processing verification result:', error);
    return { success: false, error: error.message };
  }
};


const handleDeleteBank = async (pmId) => {
  try {
    const requestOptions = {
      method: "POST",
      headers: { ...authHeader(), "Content-Type": "application/json" },
      body: JSON.stringify({
        pmId
      }),
    };
    return fetch(`${constant.apiUrl}/subscription/delete-bank`, requestOptions).then(handleResponse)
    .then((res) => {
      return res;
    });
  } catch (error) {
    console.error('Error delete bank:', error);
    return { success: false, error: error.message };
  }
};


export const subscriptionService = {
  getSubscriptionPlans,
  getSubscriptionInfo,
  subscribe,
  // changePlan,
  getSources,
  makePrimary,
  updateSubscription,


  processVerificationResult,
  createFinancialConnectionsSession,
  handleDeleteBank,

  

};